<template lang="pug" functional>
  div(:class="props.status")
    .status {{ `status.${props.status}` | translate }}
</template>

<script>
export default {
  name: 'StatusLabel',

  props: {
    status: {
      type: String,
      default: 'waited'
    }
  }
}
</script>

<style lang="scss" scoped>
  .status {
    width: 115px;
    font-size: 14px;
    position: relative;
    padding-left: 22px;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 12px;
      width: 12px;
      border-radius: 50%;
    }
  }

  .waited .status::after {
    background-color: #FF6158;
  }

  .in_process .status::after {
    background-color: #F9CD13;
  }

  .loaded .status::after {
    background-color: #1DA643;
  }
  
  .out_process .status::after {
    background-color: #e5fb19;
  }

  .uploaded .status::after {
    background-color: #006DF0;
  }
</style>
